/**
 * Route Variant for certain journeys
 */
export const ROUTE_VARIANT_VALUES = [
    'express',
    'express-io',
    'traditional-grin',
    'traditional-grin-io',
    'traditional-laut',
    'traditional-laut-io',
    'default-eigergletscher',
    'default-first',
    'default-harder',
    'default-jungfraujoch',
    'default-kls',
    'default-schynigeplatte',
    'default-winteregg',
] as const;

// Derived union from the const array — single source of truth for type + preset configurator list.
export type RouteVariant = typeof ROUTE_VARIANT_VALUES[number];
